"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNDEFINED_VARIABLE_MESSAGE = void 0;
const UNDEFINED_VARIABLE_MESSAGE = (key) => `The environment variable "${key}" is required but not provided!`;
exports.UNDEFINED_VARIABLE_MESSAGE = UNDEFINED_VARIABLE_MESSAGE;
